export const CLASS_NAMES = {
	assistantPanel:
		'flex min-h-[72px] flex-col items-center justify-between gap-4 rounded-lg bg-[#F4F7FB] px-3 py-4 sm:flex-row sm:px-4'
} as const;
